import axiosInstance from './axiosInstance';

export interface ItemLifecycleMovementDto {
  documentNumber: string;
  date: string;
  status: string;
  documentType: string;
  quantity: number;
  unitName: string;
  unitNameAr: string;
  unitCost: number;
  totalValue: number;
  counterpartyName: string;
  counterpartyNameAr: string;
  counterpartyKind?: string;
  warehouseName?: string;
  warehouseNameAr?: string;
  notes?: string;
}

export interface ItemLifecycleSectionDto {
  sectionKey: string;
  titleEn: string;
  titleAr: string;
  lines: ItemLifecycleMovementDto[];
  totalQuantity: number;
  totalValue: number;
  lineCount: number;
}

export interface ItemLifecycleReportResultDto {
  generatedAt: string;
  itemId: number;
  itemCode: string;
  itemName: string;
  itemNameAr: string;
  warehouseId: number;
  warehouseName: string;
  warehouseNameAr: string;
  allWarehouses: boolean;
  primaryUnitName: string;
  primaryUnitNameAr: string;
  fromDate?: string;
  toDate?: string;
  openingQuantity: number;
  openingValue: number;
  opening: ItemLifecycleSectionDto;
  purchases: ItemLifecycleSectionDto;
  transfersIn: ItemLifecycleSectionDto;
  issues: ItemLifecycleSectionDto;
  transfersOut: ItemLifecycleSectionDto;
  internalIssues: ItemLifecycleSectionDto;
  stockCounts: ItemLifecycleSectionDto;
  totalInQuantity: number;
  totalInValue: number;
  totalOutQuantity: number;
  totalOutValue: number;
  stockCountNetVariance: number;
  stockCountNetVarianceValue: number;
  expectedEndingQuantity: number;
  currentStockLevelQuantity: number;
  mismatch: number;
}

export const itemLifecycleService = {
  getReport: async (
    itemId: number,
    warehouseId: number, // pass 0 for "All Warehouses"
    fromDate?: string,
    toDate?: string,
  ): Promise<ItemLifecycleReportResultDto> => {
    const params = new URLSearchParams();
    params.append('itemId', itemId.toString());
    params.append('warehouseId', (warehouseId || 0).toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);
    const { data } = await axiosInstance.get(`/ItemLifecycleReport?${params.toString()}`);
    return data;
  },
};
